import { useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";

/** Every monitoring read (provider status, pool status, rules, previews)
 * can change when a target or rule changes, so refresh them together.
 * Turning monitoring on also subscribes the user to the results email, so
 * their notification preferences are refreshed too. The workspace roster
 * refreshes itself through `useWorkspaceRefresh`. */
export function useInvalidateMonitoring() {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return () =>
    Promise.all([
      queryClient.invalidateQueries(trpc.psv.monitoring.pathFilter()),
      queryClient.invalidateQueries(
        trpc.user.listOrgNotificationPreferences.pathFilter(),
      ),
    ]);
}
